module.exports = __webpack_public_path__ + "img/eye-dropper-half.6a29db59.svg";